import FednowTabs from "./FednowTabs";

import FedNowTransactionTable from "./FedNowTransactionTable";
import { useParams } from "react-router-dom";

type IdParam = {
  id: string | undefined;
};

export default function FednowDelinedContainer() {
  const { id } = useParams<IdParam>();

  return (
    <FednowTabs tab="declined">
      <div className="padding--y" style={{ display: "block" }}>
        <FedNowTransactionTable state="declined,overridden,overridden_settled" selectedId={id} />
      </div>
    </FednowTabs>
  );
}
